import React from "react";
import './HowToUse.css';

export const HowToUse = () => {
  return (
    <div id="how-to-use">
      <center>
        <h1 style={{ color: "rgb(255,255,255)", fontSize: "40px" }}>
          How to use
        </h1>
        <br />
        <br />
        <h3 style={{ color: "rgb(255,255,255)" }}>1. Adding your Data/File</h3>
        <p style={{ color: "rgb(255,255,255)" }}>
          <br />
            For adding your data, simply enter the required details like your Name, <br/>
            the content for Text Section or Choose file for File Section along with entering<br/>
            your Email and also create your unique Password, which will be used<br/>
            later for retrieving your Data/File.<br/>
            <br />
            Finally, after entering all the data, click on Save/Retrieve/ or Upload button to<br />
            upload your data/file. It's that simple.
        </p>
        <br />
        <br />
        <h3 style={{ color: "rgb(255,255,255)" }}>2. Retrieving Data</h3>
        <p style={{ color: "rgb(255,255,255)" }}>
          <br />
            For retrieving your data, enter the password that you had set while<br/>
            adding the data along with the name or email and leave rest of the fields empty. <br />
            Click on Save/Retrieve or Download button.
            <br />
            You will see that your Data/File has been retrieved.
        </p>
        <br />
        <br />
        <p style={{ color: "rgb(255,255,255)" }}>
          Remember that anyone who has the password can retrieve the data. <br />
          So be sure to keep it safe and unique. <br/>
          Sometimes, the data may take longer time to sync due to poor network.<br/>
          Just wait for some time and if the problem persists,<br/>
          refresh the page and try again.
        </p>
      </center>
    </div>
  );
};

export default HowToUse;
